import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const abstractMembershipApi = generateNomenApi(`/abstract/abstract-membership`);

export const abstractMembershipOptions = generateNomenOptions('abstract-membership', abstractMembershipApi);
